import $ from "jquery";
import getLayout from "./get-modal-layout";
import Modal from "./modal";
import Moveable from "moveable";

class ModalExclusives extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelectorAll(`.js-modal-exclusives`);
  }

  init(locale) {
    super.createModal();
    this.locale = locale;
    this.createWrap();
    this.bindHandlers();
  }

  // TODO: make loop with objects of published flats
  createWrap() {
    super.addLayout(
      `<div class="modal-exclusives">
        <div class="modal-exclusives__apartments">
          <div class="modal-exclusives__apartment">
            <div id="exclusive-apt-3" class="modal-exclusives__apartment__image">
            </div>
            <div class="modal-exclusives__apartment__info">
              <span>Резиденция со знаменитой гостиной работы архитектора фон Генрихсена</span>
              <span>355 м2</span>
            </div>
            <a href="/flats/kvartira-19" class="modal-exclusives__apartment__button">Подробнее</a>
          </div>

          <div class="modal-exclusives__apartment">
            <div id="exclusive-apt-1" class="modal-exclusives__apartment__image">
            </div>
            <div class="modal-exclusives__apartment__info">
              <span>Коллекционная резиденция с эксклюзивным дизайном и видом на Неву</span>
              <span>165 м2</span>
            </div>
            <a href="/flats/kvartira-29" class="modal-exclusives__apartment__button">Подробнее</a>
          </div>

          <div class="modal-exclusives__apartment">
            <div id="exclusive-apt-2" class="modal-exclusives__apartment__image">
            </div>
            <div class="modal-exclusives__apartment__info">
              <span>Двухуровневая резиденция c террасой и панорамным видом на Неву</span>
              <span>394.1 м2</span>
            </div>
            <a href="/flats/kvartira-5" class="modal-exclusives__apartment__button">Подробнее</a>
          </div>
        </div>
      </div>`
    );
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  bindHandlers() {
    this.toggle &&
      this.toggle.forEach(el => {
        el.addEventListener(`click`, (ev) => {
          ev.preventDefault();
          this._toggleModal(true);
        });
      });
  }
}

const modalExclusives = new ModalExclusives();

export default modalExclusives;
